import React, { Fragment } from "react";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";

const NormalHeader = ({ mainStyle = {}, children, iconStyle = "", active, handleActive, i, title }: any) => {
    return (
        <div className="data-grid has-lines">
            <div style={mainStyle}>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="breach-exposure-risk-rating-card" onClick={() => handleActive(i)}>
                            <div className="breach-paging-goto">
                                <span style={{ fontSize: 20 }}>
                                    <RenderIcons iconName="circle" />
                                </span>
                                <h3 className="collapse-title-text breach-pending-title" style={{ paddingLeft: "0.5rem" }}>
                                    {title}
                                </h3>
                            </div>
                            <span style={{ paddingTop: 3 }}>
                                <em
                                    className={`${iconStyle} las la-caret-down`}
                                    style={{
                                        transform: active === i ? "rotate(180deg)" : "",
                                    }}
                                ></em>
                            </span>
                        </div>
                    </div>
                </div>
                {active === i ? (
                    <div className="collapse-text" style={{ paddingBottom: "2.1875rem", paddingTop: "1.625rem" }}>
                        {children[i]}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

const ActionCollapse = ({ children, headers, iconStyle = "", mainStyle = {}, active, setActive }: any) => {
    const handleActive = (i: any) => {
        if (active === i) {
            setActive("");
            return false;
        }
        setActive(i);
    };

    return Array.isArray(children)
        ? headers.map((title: any, i: any) => {
            return (
                <Fragment key={i}>
                    <NormalHeader
                        mainStyle={mainStyle}
                        iconStyle={iconStyle}
                        children={children}
                        handleActive={handleActive}
                        active={active}
                        i={i}
                        title={title}
                    />
                </Fragment>
            );
        })
        : null;
};

export default ActionCollapse;
